/**
 * Generates a 6-character XID (error identifier) in format XX-XX-XX
 * Mix of uppercase letters and numbers
 */
export const generateXID = (): string => {
	const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
	let xid = '';

	for (let i = 0; i < 6; i++) {
		xid += chars.charAt(Math.floor(Math.random() * chars.length));
	}

	// Format as XX-XX-XX
	return `${xid.slice(0, 2)}-${xid.slice(2, 4)}-${xid.slice(4, 6)}`;
};
